export default __webpack_public_path__ + "static/banner-5b13a3c4d787261b64c19efb26737a4a.jpg";